var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('home'),_c('v-row',{staticClass:"mt-4"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('h2',[_vm._v(" "+_vm._s(_vm.$t('SubscribePackages'))+" ")])]),_c('v-col',{attrs:{"cols":"12"}},[_c('PricingPlansList',{attrs:{"type":'online'}})],1)],1),_c('DownloadSection',{attrs:{"mobile":_vm.mobile}}),_c('PaymentSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }